var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import './patient-term-service.css';
import PatientTermServiceApi from './patient-term-service-api';
import React, { PureComponent } from 'react';
import { bool, eventListener, object, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { Button, Checkbox } from '@philips-internal/oswald-ui-components';
import { ButtonType, Size } from '@philips-internal/oswald-ui-constants';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
let PatientTermService = class PatientTermService extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            check: false
        };
        this.getTermo = () => {
            const { data } = this.props;
            return data && data.termo;
        };
    }
    static { this.DefaultProps = {
        showCheck: false
    }; }
    static { this.propTypes = {
        data: object,
        enabled: bool,
        label: string,
        onSubmitTermUse: eventListener,
        showCheck: bool,
    }; }
    SubmitTermUse() {
        const { onSubmitTermUse } = this.props;
        onSubmitTermUse && onSubmitTermUse(new ClickEvent());
    }
    onCheck() {
        this.setState({ check: !this.state.check });
    }
    renderConfirmButton(buttonName = 'patient.button.confirm', forceEnabled = false) {
        return (React.createElement("div", { className: "c-term-service__check-button" },
            React.createElement(Button, { size: Size.LARGE, value: MessageService.translate(buttonName), type: ButtonType.SUBMIT, enabled: forceEnabled || this.state.check, onClick: () => this.SubmitTermUse() })));
    }
    renderCheckBoxAndButton() {
        const { showCheck, endpoint, enabled } = this.props;
        if (showCheck && endpoint === APPLICATION_ENDPOINTS.GET_PRIVACY_BY_SEQUENCE) {
            return this.renderConfirmButton('patient.login-confirm', true);
        }
        const checkBoxUuid = generateUUID();
        if (showCheck) {
            return (React.createElement("div", { className: "c-term-service__check" },
                React.createElement("div", { className: "c-term-service__check-checkbox" },
                    React.createElement(Checkbox, { label: `${MessageService.translate('patient.agree.with.terms')} ${MessageService.translate(this.props.label)}`, onChange: () => this.onCheck(), value: this.state.check, enabled: enabled, uuid: checkBoxUuid, name: checkBoxUuid })),
                this.renderConfirmButton()));
        }
        return React.createElement(React.Fragment, null);
    }
    render() {
        return (React.createElement("div", { className: "c-term-service" },
            React.createElement("div", { className: "c-patient-term-service", dangerouslySetInnerHTML: { __html: this.getTermo() } }),
            this.renderCheckBoxAndButton()));
    }
};
PatientTermService = __decorate([
    AwesomeComponent({ api: PatientTermServiceApi, type: ComponentType.DATA_DISPLAY })
], PatientTermService);
export default PatientTermService;
//# sourceMappingURL=patient-term-service.js.map